module.exports = __webpack_public_path__ + "img/safe.777287af.svg";